import React, { useContext, useEffect, useMemo } from 'react';
// hooks
import { useVideoActualSize } from '@cube3/ui/src/Hooks/useVideoActualSize';

import DrawingCanvas from '@cube3/annotate/src/components/DrawingCanvas';
import Annotation from '@cube3/annotate/src/Annotation';
import {
  ReviewAssetViewerContext,
  ReviewToolContext
} from '../ReviewTool/Context/reviewToolContext';
import { showAnnotation } from '@cube3/annotate/src/hooks/useAnnotationTime';
import { MediaLayerProps } from '@cube3/ui/src/previews/VideoPreview/MediaPlayer';
import { PanZoomContext } from '@cube3/ui/src/previews/ImagePreview/PanZoomContext';

export const AnnotationLayer = (props: MediaLayerProps) => {
  const {
    playedSeconds,
    mediaElement,
    frameRate,
    playing,
    fullscreen,
    toggleFullscreenAction,
    type
  } = props;
  const {
    setDrawnSvg,
    setPlaying,
    drawnSvg,
    activeComment,
    drawingBarToggled,
    toggleDrawingBar
  } = useContext(ReviewToolContext);
  const { setTimestamp } = useContext(ReviewAssetViewerContext);

  useEffect(() => {
    if (playedSeconds || playedSeconds === 0) {
      setTimestamp(playedSeconds);
    }
  }, [playedSeconds]);

  useEffect(() => {
    setPlaying(playing);
  }, [playing]);

  const zoom = useContext(PanZoomContext)?.zoom;
  const format = useVideoActualSize(mediaElement);

  const resizedFormat = useMemo(() => {
    if (!zoom) return format;
    return {
      ...format,
      width: format.width * zoom,
      height: format.height * zoom
    };
  }, [zoom, format]);

  const shouldShow = frameRate
    ? showAnnotation(activeComment, playedSeconds, frameRate / 1000 / 2)
    : true;

  const translation = useContext(PanZoomContext)?.translation;

  return (
    <>
      {drawingBarToggled ? (
        <DrawingCanvas
          saveAnnotation={setDrawnSvg}
          drawnSvg={drawnSvg}
          format={resizedFormat}
          annotationToggled={drawingBarToggled}
          playedSeconds={playedSeconds}
          fullscreen={fullscreen}
          toggleDrawingBar={toggleDrawingBar}
          toggleFullscreenAction={toggleFullscreenAction}
          translation={translation}
        />
      ) : activeComment?.drawing_svg && shouldShow ? (
        <Annotation annotation={activeComment} format={resizedFormat} assetType={type} />
      ) : null}
    </>
  );
};
